import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const VerifiedBadge = (props: SvgProps) => (
  <Svg width={21} height={20} fill="none" {...props}>
    <Path fill="#fff" d="M5 7h10v7H5z" />
    <Path
      fill="#C0A46F"
      d="m7.235 20-1.81-3.056-3.456-.737.344-3.55L0 10l2.313-2.657-.344-3.548 3.458-.737L7.233 0l3.216 1.375L13.665 0l1.81 3.056 3.455.737-.343 3.55L20.9 10l-2.313 2.657.343 3.548-3.457.737L13.666 20l-3.216-1.375L7.235 20Zm2.073-6.931 5.37-5.37-.73-.725-4.636 4.639-2.36-2.36-.73.73 3.086 3.086Z"
    />
  </Svg>
);
export default VerifiedBadge;
